var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiDialogActions from '@material-ui/core/DialogActions';
/**
 * Kareo wrapped component of the Material-UI DialogActions. The prop API has been limited to props defined in DialogActionsProps.
 *
 * Material-UI DialogActions: [Docs](https://v4.mui.com/components/dialogs/), [API](https://v4.mui.com/api/dialog-actions/)
 *
 * @storybook: [Dialog](http://design.kareoprod.ent/design-system/?path=/story/components-feedback-dialog)
 */
var DialogActions = React.forwardRef(function (props, ref) {
    return React.createElement(MuiDialogActions, __assign({}, props, { ref: ref }));
});
DialogActions.displayName = 'KareoDialogActions';
export default DialogActions;
